package pl.decks.personal.pages.ievp

import androidx.compose.runtime.Composable
import org.w3c.dom.Element

data class IEVPPageState(
    val activeSection: IEVPSection = IEVPSection.WHY,
    val sectionProgress: Map<IEVPSection, Float> = IEVPSection.entries.associateWith { 0f },
    val headerProgress: Map<IEVPSection, Float> = IEVPSection.entries.associateWith {
        if (it == activeSection) 1f else 0f
    },
    val sectionReached: Set<IEVPSection> = emptySet(),
    val viewPortProgress: Map<IEVPSection, Float> = IEVPSection.entries.associateWith { 0f },
    val scrollToSection: IEVPSection? = null,
    val background: (@Composable (transition: Float) -> Unit)? = IEVPSection.WHY.background,
    val incomingBackground: (@Composable (transition: Float) -> Unit)? = null,
    val incomingTransition: Float = 0f,
) {
    data class SectionMeasures(
        val headingProgress: Float,
        val viewPortProgress: Float,
        val sectionProgress: Float,
    ) {
        companion object {
            fun fromElements(
                sectionElement: Element,
                scrollingArea: Element,
                readLineFraction: Float,
            ): SectionMeasures {
                val scrollingRect = scrollingArea.getBoundingClientRect()
                val sectionRect = sectionElement.getBoundingClientRect()

                val readLine = scrollingRect.top + readLineFraction * scrollingRect.height
                val readingAreaTotal = (1 - readLineFraction) * scrollingRect.height
                val sectionTotal = readingAreaTotal + sectionRect.height
                val viewPortTotal = scrollingRect.height + sectionRect.height
                val headingLevel = 1 - (sectionRect.top - readLine) / readingAreaTotal
                val viewPortLevel = 1 - (sectionRect.bottom - scrollingRect.top) / viewPortTotal
                val sectionLevel = 1 - (sectionRect.bottom - readLine) / sectionTotal
                return SectionMeasures(
                    headingProgress = headingLevel.toFloat().coerceIn(0f, 1f),
                    viewPortProgress = viewPortLevel.toFloat().coerceIn(0f, 1f),
                    sectionProgress = sectionLevel.toFloat().coerceIn(0f, 1f),
                )
            }
        }
    }

}
